import { Nav } from '../Nav';
import { Logo } from '../Logo';
import { MainSponsorLogo } from '../MainSponsorLogo';
import { useDeviceType } from '@ui/utils/useDeviceType';
import { DeviceType } from '@repo/types';

function Header() {
  console.log('Header');
  const deviceType = useDeviceType();
  const isMobile = deviceType === DeviceType.mobile;

  if (isMobile) {
    return (
      <header className="header">
        <div className={'header__logos-container'}>
          <Logo />
          <MainSponsorLogo />
        </div>
        <Nav className="header__nav" />
      </header>
    );
  }

  return (
    <header className="header">
      <Logo />
      <Nav className="header__nav" />
      <MainSponsorLogo />
    </header>
  );
}

export default Header;
